import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export const RevealLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ no, en, zh, right = null }) => {
  const { lang } = useLang();
  return (
    <FadeUp className="flex items-end justify-between gap-6 border-b border-white/10 pb-6 mb-10 md:mb-16">
      <div>
        <div className="font-mono2 text-xs text-[#ffde00] tracking-[0.3em] mb-3">
          {no} — {en}
        </div>
        <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] text-[#f5f5f5]">
          {lang === "zh" ? zh : en}
        </h2>
      </div>
      {right}
    </FadeUp>
  );
};
